import canUseDOM from './can-use-dom'

/**
 * Returns the app base URL for server-side code (SSR/build scripts).
 * Use this when `window` is unavailable, such as in Gatsby Node APIs or SSR.
 */
export const getServerSideURL = () => {
  let url = process.env.GATSBY_PUBLIC_SERVER_URL

  if (!url && process.env.SITE_URL) {
    return `https://${process.env.SITE_URL}`
  }

  if (!url) {
    url = 'http://localhost:3000'
  }

  return url
}

/**
 * Returns the app base URL for browser-side code.
 * Use this in React components/hooks where `window.location` is available.
 */
export const getClientSideURL = () => {
  if (canUseDOM) {
    const protocol = window.location.protocol
    const domain = window.location.hostname
    const port = window.location.port

    return `${protocol}//${domain}${port ? `:${port}` : ''}`
  }

  if (process.env.SITE_URL) {
    return `https://${process.env.SITE_URL}`
  }

  return process.env.GATSBY_PUBLIC_SERVER_URL || ''
}
